﻿import { useEffect, useState, useCallback, useRef } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
  Switch,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import Pageheader from "../common/Pageheader";
import { useSelector, useDispatch } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest.jsx";
import { Getrequestcall } from "../../request/Getrequest.jsx";
import {
  CHANGE_RIDE_SHARE_FOR_USER,
  FETCH_USERS_2,
  FETCH_USERS_INTERESTED_IN_RIDESHARE_USING_POSTAL_CODE,
  GET_PEOPLE_INTEREST_IN_RIDE_SHARE,
  FETCH_CARPOOL_USER_SETTINGS,
  SAVE_CARPOOL_USER_SETTINGS
} from "../../constant/Apipath.jsx";
import Loader from "../../common/Loader.jsx";
import Emptydata from "../common/Emptydata";
import { useNavigate } from "react-router-dom";
import { setCarpoolOptLoader, setCarpoolSwitchValue } from "../../redux/actions/actions.jsx";
import { English } from "../../constant/EnglishFallback.jsx";
import { ChatBubble, LocationOn, SyncAlt } from "@mui/icons-material";
import { BIBlue, BIRed } from "../../assets/helpers.jsx";
import SedanCarImg from "../../assets/images/sedan car-rafiki.png";
import LostPersonImg from "../../assets/images/Lost-rafiki.png";
import PostalCodeDialogue from "./PostalCodeDialogue.jsx";
import SiteListModal from "./SiteListModal.jsx";
import LocationNeededModal from "./LocationNeededModal.jsx";
import Getcurrentlocation from "../../common/Getcurrentlocation";
import AdContainer from "../common/AdContainer.jsx";
import { createChatGroupAndNavigate } from "../../common/Helper.jsx";

function Carpool() {
  const [interested, setInterested] = useState(false);
  const [mainLoading, setMainLoading] = useState(false);
  const [siteLoading, setSiteLoading] = useState(false);
  const [nearbyLoading, setNearbyLoading] = useState(false);
  const [postalCodePopup, setPostalCodePopup] = useState(false);
  const [openSiteListModal, setOpenSiteListModal] = useState(false);
  const [nearbyUserList, setNearbyUserList] = useState([]);
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [locationOnProfile, setLocationOnProfile] = useState(true);

  // Infinite scroll states
  const [pageNo, setPageNo] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isInfiniteLoading, setIsInfiniteLoading] = useState(false);

  // Local state
  const [selectedSite, setSelectedSite] = useState({});
  const [postalCodeText, setPostalCodeText] = useState("");
  const [carpoolSettings, setCarpoolSettings] = useState(null);

  // Refs to prevent multiple calls
  const abortControllerRef = useRef(null);
  const isLoadingRef = useRef(false);

  const { loginData, multiLanguageData, carpoolOptLoader, carpoolOnlyShowPeople } = useSelector(
    (state) => state?.main
  );

  const onlyShowPeople = carpoolOnlyShowPeople || false;
  const userId = loginData?.userInformation?.UserId;
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const LanguageData = multiLanguageData?.Carpool || {};
  const {
    TEXT_CARPOOL_HEADER = English.Carpool.TEXT_CARPOOL_HEADER,
    TEXT_KM_AWAY = English.Carpool.TEXT_KM_AWAY,
    TEXT_SHARE_YOUR_LOCATION_TO_SEE = English?.Carpool?.TEXT_SHARE_YOUR_LOCATION_TO_SEE,
    BUTTON_JOIN_CARPOOL = English?.Carpool?.BUTTON_JOIN_CARPOOL,
    TEXT_MY_SITE = English?.Carpool?.TEXT_MY_SITE,
    BUTTON_SELECT_SITE_FROM_PROFILE = English?.Carpool?.BUTTON_SELECT_SITE_FROM_PROFILE,
    TEXT_ONLY_SHOW_PEOPLE = English?.Carpool?.TEXT_ONLY_SHOW_PEOPLE,
    TEXT_NEARBY_CARPOOLERS = English?.Carpool?.TEXT_NEARBY_CARPOOLERS,
    TEXT_NO_NEARBY_MATCHES_RIGHT_NOW = English?.Carpool?.TEXT_NO_NEARBY_MATCHES_RIGHT_NOW
  } = LanguageData || {};

  const { TEXT_NO_ADDRESS = English.SiteListModal.TEXT_NO_ADDRESS } =
    multiLanguageData?.SiteListModal || {};

  const { TEXT_LOCATION_NEEDED = English.LocationNeededModal.TEXT_LOCATION_NEEDED } =
    multiLanguageData?.LocationNeededModal || {};

  useEffect(() => {
    fetchCarpoolUserSettings();

    // Cleanup
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    if (carpoolOptLoader?.optedFlag === "Opt Out Carpool") {
      setNearbyUserList([]);
      setInterested(false);
    }
  }, [carpoolOptLoader]);

  // OPTIMIZED: Reset pagination with ref check
  const resetPagination = useCallback(() => {
    console.log("🔄 Resetting pagination");
    setPageNo(1);
    setNearbyUserList([]);
    setHasMore(true);
    setIsInfiniteLoading(false);
  }, []);

  // FIXED: Don't use saved postal code - always check current location
  const fetchCarpoolUserSettings = async () => {
    if (isLoadingRef.current) return;

    isLoadingRef.current = true;
    setMainLoading(true);

    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 10,
        FullSearch: "",
        UserId: userId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [{ UserId: userId }],
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };

      let res = await Postrequestcall(FETCH_CARPOOL_USER_SETTINGS, obj, loginData?.accessToken);

      if (res?.status === 201 && res?.data?.message === "OK") {
        if (res?.data?.data[0]) {
          const settings = res?.data?.data[0];
          console.log("📋 Got settings:", settings);

          setCarpoolSettings(settings);
          setInterested(settings.rideShareInterested);

          // Set selected site
          if (settings.siteId) {
            setSelectedSite({
              siteId: settings.siteId,
              siteName: settings.siteName,
              address: settings.siteAddress,
              city: settings.siteCity,
              country: settings.siteCountry,
              province: settings.siteProvince,
              postalCode: settings.sitePostalCode,
              latitude: settings.latitude,
              longitude: settings.longitude
            });
          }

          // FIXED: Always check current location - ignore saved postal code
          if (settings.rideShareInterested === true) {
            console.log("✅ User interested - checking current location");
            await checkCurrentLocation();
          } else {
            console.log("❌ User not interested");
            setMainLoading(false);
          }
        } else {
          console.log("⚠️ No settings found");
          setMainLoading(false);
        }
      } else {
        setMainLoading(false);
      }
    } catch (error) {
      console.log("❌ FETCH_CARPOOL_USER_SETTINGS [ERROR] : ", error);
      setMainLoading(false);
    } finally {
      isLoadingRef.current = false;
    }
  };

  // Check current location - always called
  const checkCurrentLocation = async () => {
    try {
      console.log("🌍 Checking current location...");
      let getValue = await Getcurrentlocation();

      if (getValue.default) {
        console.log("❌ Location permission denied");
        setMainLoading(false);
        setLocationModalOpen(true);
      } else if (getValue?.lat && getValue?.lng) {
        console.log("✅ Got location coordinates");
        setLocationModalOpen(false);
        await getLocationPostalCode(getValue.lat, getValue.lng);
      } else {
        console.log("❌ Location failed");
        setMainLoading(false);
        setLocationModalOpen(true);
      }
    } catch (error) {
      console.log("❌ Location check error:", error);
      setMainLoading(false);
      setLocationModalOpen(true);
    }
  };

  // Get postal code from coordinates
  const getLocationPostalCode = async (latitude, longitude) => {
    try {
      console.log("🗺️ Getting postal code from coordinates...");
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${import.meta.env.REACT_APP_GOOGLE_MAP_KEY}`
      );
      const data = await res.json();

      if (data.status === "OK") {
        let postal = "";
        for (const component of data.results[0].address_components) {
          if (component.types.includes("postal_code")) {
            postal = component.long_name;
            break;
          }
        }

        if (postal) {
          console.log("✅ Got postal code from location:", postal);
          setPostalCodeText(postal);
          resetPagination();
          await getNearbyCarpoolersList(postal, 1, true);
          await saveCarpoolUserSettings(postal, selectedSite?.siteId);
          dispatch(setCarpoolOptLoader({ optedFlag: "Join Carpool" }));
        } else {
          console.log("❌ No postal code found in geocoding");
          setLocationModalOpen(true);
        }
      } else {
        console.log("❌ Geocoding failed:", data.status);
        setLocationModalOpen(true);
      }
    } catch (err) {
      console.log("❌ Geocoding error:", err);
      setLocationModalOpen(true);
    } finally {
      setMainLoading(false);
    }
  };

  // OPTIMIZED: Fetch nearby carpoolers with proper infinite scroll
  const getNearbyCarpoolersList = useCallback(
    async (postal, pageNumber = pageNo, isReset = false) => {
      if (!postal) {
        console.log("❌ No postal code provided");
        return;
      }

      // Prevent duplicate calls
      if (isReset && nearbyLoading) return;
      if (!isReset && isInfiniteLoading) return;

      console.log(`📡 Fetching carpoolers - Page: ${pageNumber}, Reset: ${isReset}`);

      // Cancel previous request
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();

      try {
        if (isReset) {
          setNearbyLoading(true);
        } else {
          setIsInfiniteLoading(true);
        }

        const obj = {
          PostalCode: postal,
          UserId: userId,
          PageNumber: pageNumber,
          PageSize: 10
        };

        const response = await Postrequestcall(
          FETCH_USERS_INTERESTED_IN_RIDESHARE_USING_POSTAL_CODE,
          obj,
          loginData?.accessToken
        );

        const newData = response?.data?.data || [];
        console.log(`✅ Received ${newData.length} carpoolers for page ${pageNumber}`);

        if (newData.length > 0) {
          if (isReset) {
            setNearbyUserList(newData);
          } else {
            // FIXED: Prevent duplicates
            setNearbyUserList((prev) => {
              const existingIds = new Set(prev.map((item) => item.userId));
              const filteredNewData = newData.filter((item) => !existingIds.has(item.userId));
              console.log(`➕ Adding ${filteredNewData.length} unique items`);
              return [...prev, ...filteredNewData];
            });
          }

          // FIXED: Update page number for next call
          if (!isReset) {
            setPageNo(pageNumber + 1);
          }

          setHasMore(newData.length === 10); // Has more if full page
        } else {
          console.log("📄 No more data - end of list");
          setHasMore(false);
        }

        dispatch(setCarpoolOptLoader({ optedFlag: "Join Carpool" }));
      } catch (err) {
        if (err.name !== "AbortError") {
          console.log("❌ FETCH_USERS_INTERESTED_IN_RIDESHARE_USING_POSTAL_CODE [ERROR] : ", err);
          setHasMore(false);
        }
      } finally {
        setNearbyLoading(false);
        setIsInfiniteLoading(false);
      }
    },
    [nearbyLoading, isInfiniteLoading, pageNo, userId, loginData?.accessToken, dispatch]
  );

  // Get user profile information
  const getUserinformation = async () => {
    try {
      setMainLoading(true);
      console.log("👤 Getting user profile information...");

      let getUserinfo = await Postrequestcall(
        FETCH_USERS_2,
        { SearchList: [{ Id: userId }] },
        loginData?.accessToken
      );

      if (getUserinfo?.status === 201) {
        const data = getUserinfo?.data?.data[0];
        if (data.postalCode && data.postalCode !== "") {
          console.log("✅ Found postal code in profile:", data.postalCode);
          setPostalCodeText(data.postalCode);
          handleInterested();
          resetPagination();
          await getNearbyCarpoolersList(data.postalCode, 1, true);
          await saveCarpoolUserSettings(data.postalCode, selectedSite?.siteId);
          setLocationModalOpen(false);
          setLocationOnProfile(true);
        } else {
          console.log("❌ No postal code in profile");
          setLocationOnProfile(false);
        }
      } else {
        setLocationOnProfile(false);
      }
    } catch (error) {
      console.log("❌ getUserinformation -> Error: ", error);
      setLocationOnProfile(false);
    } finally {
      setMainLoading(false);
    }
  };

  // Get site-specific people
  const getPeoplelistRideshare = async (siteId) => {
    try {
      setSiteLoading(true);
      console.log("🏢 Getting site-specific carpoolers:", siteId);

      let getRideshare = await Getrequestcall(
        `${GET_PEOPLE_INTEREST_IN_RIDE_SHARE}/${userId}/${siteId}`,
        loginData?.accessToken
      );

      if (getRideshare?.status === 200) {
        setNearbyUserList(getRideshare?.data?.data || []);
        setHasMore(false); // Site data doesn't paginate
      }
    } catch (error) {
      console.log("❌ getPeoplelistRideshare error", error);
    } finally {
      setSiteLoading(false);
    }
  };

  // Handle interested state
  const handleInterested = useCallback(() => {
    console.log("✅ Setting user as interested");
    onRidesharecall(true);
    setInterested(true);
  }, []);

  const onRidesharecall = async (interestedFlag) => {
    try {
      const getObj = {
        UserId: userId,
        RideShareInterested: interestedFlag
      };
      await Postrequestcall(CHANGE_RIDE_SHARE_FOR_USER, getObj, loginData?.accessToken);
    } catch (error) {
      console.log("❌ onRidesharecall error", error);
    }
  };

  // OPTIMIZED: Save settings with debouncing
  const saveCarpoolUserSettings = useCallback(
    async (newPostalCode, newSiteId) => {
      if (!newPostalCode && !newSiteId) return;

      try {
        console.log("💾 Saving carpool settings:", { newPostalCode, newSiteId });
        const obj = {
          UserId: userId,
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: carpoolSettings?.id || 0,
              UserId: userId,
              PostalCode: newPostalCode || postalCodeText || "",
              SiteId: newSiteId || selectedSite?.siteId || 0
            }
          ]
        };
        await Postrequestcall(SAVE_CARPOOL_USER_SETTINGS, obj, loginData?.accessToken);
      } catch (error) {
        console.log("❌ saveCarpoolUserSettings [ERROR] : ", error);
      }
    },
    [carpoolSettings?.id, userId, postalCodeText, selectedSite?.siteId, loginData?.accessToken]
  );

  // Event handlers
  const handleJoinCarpool = async () => {
    setMainLoading(true);
    dispatch(setCarpoolOptLoader({ isLoading: true, optedFlag: "" }));
    handleInterested();
    await checkCurrentLocation();
    dispatch(setCarpoolOptLoader({ isLoading: false, optedFlag: "" }));
  };

  const handlePostalCodeChange = useCallback(
    (newPostalCode) => {
      console.log("📍 Postal code changed to:", newPostalCode);
      setPostalCodeText(newPostalCode);
      resetPagination();
      getNearbyCarpoolersList(newPostalCode, 1, true);
      saveCarpoolUserSettings(newPostalCode, selectedSite?.siteId);
    },
    [resetPagination, getNearbyCarpoolersList, saveCarpoolUserSettings, selectedSite?.siteId]
  );

  const handleSiteSelection = useCallback(
    (site) => {
      console.log("🏢 Site selected:", site?.siteName);
      setSelectedSite(site);
      dispatch(setCarpoolSwitchValue(false));
      resetPagination();

      if (postalCodeText) {
        getNearbyCarpoolersList(postalCodeText, 1, true);
      }
      saveCarpoolUserSettings(postalCodeText, site?.siteId);
    },
    [dispatch, resetPagination, postalCodeText, getNearbyCarpoolersList, saveCarpoolUserSettings]
  );

  const handleToggle = useCallback(
    (event) => {
      const checked = event.target.checked;
      dispatch(setCarpoolSwitchValue(checked));
      resetPagination();

      if (checked === true) {
        if (selectedSite?.siteId) {
          getPeoplelistRideshare(selectedSite.siteId);
        }
      } else {
        if (postalCodeText) {
          getNearbyCarpoolersList(postalCodeText, 1, true);
        }
      }
    },
    [dispatch, resetPagination, selectedSite?.siteId, postalCodeText, getNearbyCarpoolersList]
  );

  const navigateTochat = async (e, chatUserId) => {
    e.preventDefault();
    createChatGroupAndNavigate(chatUserId, loginData, dispatch, navigate);
  };

  // FIXED: Optimized render with proper keys
  const RenderAvailableusers = useCallback(
    (itemList) =>
      itemList.map((item) => (
        <Card
          key={item?.userId} // Use unique userId as key
          className="pagelist-content"
          sx={{ marginTop: "0px" }}>
          <ListItem
            sx={{ m: 0 }}
            secondaryAction={
              <IconButton color="action" onClick={(e) => navigateTochat(e, Number(item?.userId))}>
                <ChatBubble />
              </IconButton>
            }
            disablePadding>
            <ListItemButton
              sx={{ display: "flex", flexDirection: "row", p: 0, pl: 2 }}
              onClick={() => navigate(`/${item?.userId}`)}>
              <ListItemAvatar>
                <Avatar alt="contact-PictureUrl" src={item?.pictureUrl} />
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant="body1" maxWidth={"430px"} noWrap>
                    {`${item?.firstName} ${item?.lastName}`}
                  </Typography>
                }
                secondary={
                  <Typography variant="body2" maxWidth={"430px"} noWrap>
                    {`${item?.distance} ${TEXT_KM_AWAY}`}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
        </Card>
      )),
    [navigateTochat, navigate, TEXT_KM_AWAY]
  );

  // FIXED: Infinite scroll load more function
  const loadMoreCarpoolers = useCallback(() => {
    if (!hasMore || isInfiniteLoading || !postalCodeText) return;
    console.log("📜 Loading more carpoolers - Page:", pageNo);
    getNearbyCarpoolersList(postalCodeText, pageNo, false);
  }, [hasMore, isInfiniteLoading, postalCodeText, pageNo, getNearbyCarpoolersList]);

  // Loading state
  if (mainLoading || carpoolOptLoader?.isLoading) {
    return (
      <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
        <Grid sx={{ pb: 1.5,  display: "flex", alignItems: "center",  justifyContent: "space-between" }}  container spacing={1}>
          <Grid size={{ xs: 4, sm: 4, md: 4, lg: 4 }}>
            <Pageheader headerName={TEXT_CARPOOL_HEADER} />
          </Grid>
        </Grid>
        <Loader />
      </Box>
    );
  }

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Grid sx={{ pb: 1.5,  display: "flex", alignItems: "center",  justifyContent: "space-between" }}  container spacing={1}>
        <Grid size={{ xs: 4, sm: 4, md: 4, lg: 4 }}>
          <Pageheader headerName={TEXT_CARPOOL_HEADER} />
        </Grid>
      </Grid>

      {!interested || carpoolOptLoader?.optedFlag === "Opt Out Carpool" ? (
        <div style={{ height: "100%", background: "white" }}>
          <Emptydata
            icon={<img src={SedanCarImg} style={{ width: "400px", height: "400px" }} />}
            firstText={TEXT_SHARE_YOUR_LOCATION_TO_SEE}
            buttonText={BUTTON_JOIN_CARPOOL}
            onButtonClick={handleJoinCarpool}
          />
        </div>
      ) : (
        <Grid
          sx={{ height: isSmallScreen ? "auto" : "100%", mt: 0 }}
          container
          spacing={2}
          className={interested ? "main-content-carpool-card" : "main-content-card"}>
          {/* Left Side Card */}
          <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
            <Card sx={{ borderRadius: 3, boxShadow: 3, p: 0.5 }}>
              <CardContent>
                <Typography variant="subtitle2" sx={{ mb: 2,  color: "text.secondary" }} >
                  {TEXT_MY_SITE}
                </Typography>

                {!selectedSite || Object.keys(selectedSite).length === 0 ? (
                  <Button fullWidth variant="outlined" onClick={() => setOpenSiteListModal(true)}>
                    {BUTTON_SELECT_SITE_FROM_PROFILE}
                  </Button>
                ) : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                      }}>
                      <div>
                        <Typography variant="h6">{selectedSite?.siteName}</Typography>
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          {selectedSite.address
                            ? `${selectedSite.address}, ${selectedSite?.country}, ${selectedSite?.province}`
                            : TEXT_NO_ADDRESS}
                        </Typography>
                      </div>
                      <IconButton onClick={() => setOpenSiteListModal(true)}>
                        <SyncAlt fontSize="small" />
                      </IconButton>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "12px",
                        justifyContent: "space-between"
                      }}>
                      <Typography variant="body2">{TEXT_ONLY_SHOW_PEOPLE}</Typography>
                      <Switch checked={onlyShowPeople} onChange={handleToggle} color="primary" />
                    </div>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Right Side Nearby Carpoolers with FIXED Infinite Scroll */}
          <Grid
            sx={{ p: 2, height: "100%", borderRadius: 3, boxShadow: 3 }}
            className="pagelist-content"
            size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}>
            {siteLoading || nearbyLoading ? (
              <Loader />
            ) : (
              <List disablePadding>
                <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                  <Typography sx={{ p: 1 }} variant="h6">
                    {TEXT_NEARBY_CARPOOLERS}
                  </Typography>
                  <Typography
                    onClick={() => setPostalCodePopup(true)}
                    p={1}
                    variant="h6"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      color: postalCodeText ? BIBlue : BIRed,
                      cursor: "pointer"
                    }}>
                    <LocationOn fontSize="small" sx={{ color: postalCodeText ? BIBlue : BIRed }} />
                    {postalCodeText || TEXT_LOCATION_NEEDED}
                  </Typography>
                </Stack>

                {nearbyUserList?.length === 0 ? (
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Emptydata
                      icon={
                        <img
                          src={LostPersonImg}
                          style={{ width: "400px", height: "400px" }}
                          alt="No data"
                        />
                      }
                      firstText={TEXT_NO_NEARBY_MATCHES_RIGHT_NOW}
                    />
                  </Box>
                ) : (
                  <div
                    id="carpoolers_scroll_div"
                    style={{ maxHeight: "70vh", overflow: "auto", scrollbarWidth: "none" }}>
                    <InfiniteScroll
                      scrollableTarget="carpoolers_scroll_div"
                      dataLength={nearbyUserList.length}
                      next={loadMoreCarpoolers}
                      hasMore={hasMore && !onlyShowPeople}
                      loader={isInfiniteLoading ? <Loader /> : null}
                    // endMessage={
                    //   !hasMore && nearbyUserList.length > 0 ? (
                    //     <Typography variant="caption" sx={{ textAlign: 'center', p: 2, color: 'text.secondary' }}>
                    //       No more carpoolers to load
                    //     </Typography>
                    //   ) : null
                    // }
                    >
                      <Stack sx={{ gap: 1 }} >{RenderAvailableusers(nearbyUserList)}</Stack>
                    </InfiniteScroll>
                  </div>
                )}
              </List>
            )}
          </Grid>
          <AdContainer />
        </Grid>
      )}

      {/* Modals */}
      {locationModalOpen && (
        <LocationNeededModal
          open={locationModalOpen}
          onClose={() => setLocationModalOpen(false)}
          onRetry={checkCurrentLocation}
          onEnterPostal={() => {
            setPostalCodePopup(true);
            setLocationModalOpen(false);
          }}
          checkProfile={getUserinformation}
          locationOnProfile={locationOnProfile}
          navigateToProfile={() => navigate(`/${userId}`)}
        />
      )}

      {postalCodePopup && (
        <PostalCodeDialogue
          postalCodePopup={postalCodePopup}
          setPostalCodePopup={setPostalCodePopup}
          setPostalCodeText={handlePostalCodeChange}
          getNearbyCarpoolersList={getNearbyCarpoolersList}
        />
      )}

      {openSiteListModal && (
        <SiteListModal
          openSiteListModal={openSiteListModal}
          setOpenSiteListModal={setOpenSiteListModal}
          setSelectedSite={handleSiteSelection}
          handleToggle={() => {
            dispatch(setCarpoolSwitchValue(false));
            if (postalCodeText) {
              resetPagination();
              getNearbyCarpoolersList(postalCodeText, 1, true);
            }
          }}
        />
      )}
    </Box>
  );
}

export default Carpool;

